module.exports = __webpack_public_path__ + "img/bask_left_nor.b8ad7d5c.png";